export default __webpack_public_path__ + "static/media/showLess.f8b0915c.svg";